// extracted by mini-css-extract-plugin
export default {"floor_dot":"DotSpan_floor_dot__rYl21"};